import { gql } from '@apollo/client'

export const CLEAN_UP_USER = gql`
  mutation CleanUpUser($input: CleanUpUserInput!) {
    cleanUpUser(input: $input)
  }
`
